import React from 'react';
import { Typography } from '@mui/material';

const ResponsiveDialogText = ({ children }: React.PropsWithChildren<{}>) => {
  return <Typography variant='caption'>{children}</Typography>;
};

export default ResponsiveDialogText;
